import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=27176bf3&scoped=true&"
import script from "./GeneralInfo.js?vue&type=script&lang=js&"
export * from "./GeneralInfo.js?vue&type=script&lang=js&"
import style0 from "./GeneralInfo.scss?vue&type=style&index=0&id=27176bf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27176bf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
